<template>
    <BaseModal
        :isVisible="modalStatus"
        title="Veículo Reservado"
        size="lg"
        @close="clean"
    >
        <template v-slot:content>
            <div class="row">
                <!-- Imagem do Veículo -->
                <div class="col-md-5">
                    <ImageVehicle :vehicle-data="vehicleData"/>
                </div>

                <div class="col-md-7">
                    <div class="vehicle-info-container">
                        <SectionContainer
                            title="Dados da Próxima Reserva"
                            icon="calendar-check"
                        >
                            <div class="vehicle-data">
                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-car-side"></i>
                                        Veículo:
                                    </div>
                                    <div class="data-value">
                                        {{ vehicleData.description }} {{ vehicleData.color }}
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-hashtag"></i>
                                        Placa:
                                    </div>
                                    <div class="data-value plate">
                                        {{ vehicleData.board }}
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-list"></i>
                                        Tipo:
                                    </div>
                                    <div class="data-value">
                                        {{ vehicleData.vehicle_type ? vehicleData.vehicle_type.description : 'N/A' }}
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-id-card"></i>
                                        Número da Reserva:
                                    </div>
                                    <div class="data-value">
                                        #{{ reserveData.id }}
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-user"></i>
                                        Reservado Para:
                                    </div>
                                    <div class="data-value">
                                        <span>{{ reserveData.user ? reserveData.user.name : 'N/A' }}</span>
                                        <button
                                            class="btn btn-sm btn-outline-primary ml-2"
                                            @click="openModalUser(reserveData)"
                                            title="Dados do Usuário"
                                        >
                                            <i class="fas fa-user"></i>
                                        </button>
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-map-marker-alt"></i>
                                        Cidade Destino:
                                    </div>
                                    <div class="data-value">
                                        {{ getDestinationCity() }}
                                    </div>
                                </div>

                                <div class="data-row" v-if="hasRides()">
                                    <div class="data-label">
                                        <i class="fas fa-users"></i>
                                        Caronas:
                                    </div>
                                    <div class="data-value">
                                        {{ getRideNames() }}
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-calendar-alt"></i>
                                        Retirada Estimada:
                                    </div>
                                    <div class="data-value date-highlight">
                                        {{ reserveData.retreat_date }}
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-calendar-times"></i>
                                        Devolução Estimada:
                                    </div>
                                    <div class="data-value date-highlight">
                                        {{ reserveData.devolution_date }}
                                    </div>
                                </div>

                                <div class="data-row" v-if="reserveData.km_traveled">
                                    <div class="data-label">
                                        <i class="fas fa-tachometer-alt"></i>
                                        Km Rodados:
                                    </div>
                                    <div class="data-value km-value">
                                        {{ formatKilometers(reserveData.km_traveled) }} km
                                    </div>
                                </div>
                            </div>

                            <div class="action-buttons mt-4">
                                <button
                                    class="btn btn-danger"
                                    @click="cancel(reserveData.id)"
                                    title="Cancelar Reserva"
                                >
                                    <i class="fas fa-times mr-2"></i>
                                    Cancelar Reserva
                                </button>

                                <a
                                    :href="'/myreserves/edit/' + reserveData.id"
                                    class="btn btn-warning ml-2"
                                    title="Alterar Reserva"
                                >
                                    <i class="fas fa-edit mr-2"></i>
                                    Alterar Reserva
                                </a>
                            </div>

                            <div class="notification-section mt-3">
                                <button
                                    class="btn btn-info"
                                    @click="showMessage = !showMessage"
                                    title="Enviar Notificação"
                                >
                                    <i class="fas fa-bell mr-2"></i>
                                    Enviar Notificação
                                </button>

                                <router-link
                                    :to="'/myreserves/view/' + reserveData.id"
                                    @click="clean"
                                    class="btn btn-outline-info ml-2"
                                    title="Visualizar Notificações"
                                >
                                    <i class="fas fa-eye"></i>
                                </router-link>
                            </div>

                            <!-- Campo de mensagem -->
                            <div v-if="showMessage" class="message-form mt-3">
                                <SectionContainer
                                    title="Enviar Notificação"
                                    icon="bell"
                                >
                                    <div class="form-group">
                                        <label for="message">Mensagem:</label>
                                        <input
                                            type="text"
                                            id="message"
                                            v-model="messageText"
                                            class="form-control"
                                            placeholder="Digite sua mensagem..."
                                        >
                                    </div>
                                    <div class="text-right mt-2">
                                        <button
                                            class="btn btn-sm btn-secondary mr-2"
                                            @click="showMessage = false"
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            class="btn btn-sm btn-success"
                                            @click="submitMessage(reserveData.user_id, reserveData.id)"
                                        >
                                            Enviar
                                        </button>
                                    </div>
                                </SectionContainer>
                            </div>
                        </SectionContainer>
                    </div>
                </div>
            </div>

            <!-- Histórico de Viagens -->
            <LastTripsTable
                :vehicle-data="vehicleData"
                :total-trips="totalTrips"
                :pagination-options="paginationOptions"
                @open-trip-details="openModal"
                @load-page="paginate"
            />
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '../Base/BaseModal.vue';
import SectionContainer from "./Checklist/SectionContainer.vue";
import LastTripsTable from "./Components/LastTripsTable.vue";
import ImageVehicle from "./Components/ImageVehicle.vue";
import { getMessage } from "../../composables/message";

export default {
    name: "ReservedVehicleModal", // Nome do componente: Modal de Veículo Reservado
    components: {
        ImageVehicle,
        SectionContainer,
        LastTripsTable,
        BaseModal
    },
    props: {
        modalStatus: { // modalStatus - status do modal se está aberto ou fechado
            type: Boolean,
            default: false
        },
        dataModal: { // dataModal - dados do veículo a serem exibidos no modal
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            paginationOptions: { // paginationOptions - opções de configuração da paginação
                texts: {
                    count: "Mostrando {from} de {to} até {count} de registros",
                },
                page: 1,
                chunk: 4,
                chunksNavigation: "fixed",
            },
            showMessage: false, // showMessage - controla a exibição do formulário de mensagem
            messageText: '' // messageText - texto da mensagem para notificação
        };
    },
    computed: {
        vehicleData() { // vehicleData - dados do veículo computados a partir do dataModal
            return this.dataModal || {};
        },
        reserveData() { // reserveData - dados da reserva do veículo
            return this.vehicleData.reserve_vehicle && this.vehicleData.reserve_vehicle[0] ? this.vehicleData.reserve_vehicle[0] : {};
        },
        totalTrips() { // totalTrips - total de viagens para controle da paginação
            return this.vehicleData.lastTrips ? this.vehicleData.lastTrips.total : 0;
        }
    },
    methods: {
        formatKilometers(value) { // formatKilometers - formata o valor de quilometragem com pontos
            if (!value) return '0';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        getDestinationCity() { // getDestinationCity - obtém o nome da cidade de destino
            const reserve = this.reserveData;
            if (reserve && reserve.city_destination && reserve.city_destination.city_destination) {
                return reserve.city_destination.city_destination.description;
            }
            return 'N/A';
        },
        hasRides() { // hasRides - verifica se há caronas na reserva
            return this.reserveData.ride && this.reserveData.ride.length > 0;
        },
        getRideNames() { // getRideNames - obtém os nomes das pessoas nas caronas
            if (!this.hasRides()) return '';
            return this.reserveData.ride
                .filter(ride => ride && ride.requester)
                .map(ride => ride.requester.name)
                .join(', ');
        },
        paginate(page) { // paginate - controla a paginação das viagens
            this.$emit("openModals", this.vehicleData.id, this.vehicleData.status, this.vehicleData, page);
        },
        openModal(object) { // openModal - abre modal de detalhes de viagem
            this.$emit("OMDCk", object);
        },
        openModalUser(object) { // openModalUser - abre modal do usuário
            this.$emit("OpenModalUser", object);
        },
        cancel(id) { // cancel - cancela a reserva
            this.save(id);
        },
        save(id) { // save - salva o cancelamento da reserva via API
            const api = this.$store.state.api + "reserveVehicles/" + id;
            const formData = new FormData();

            formData.append("_method", "PATCH");
            formData.append("observation", "Cancelado via Portal Admin");
            formData.append("reserve_status", "3");

            swal({
                title: "Deseja cancelar a reserva?",
                text: "Essa operação não pode ser desfeita",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, cancelar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger",
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm",
                    },
                },
            })
                .then((value) => {
                    switch (value) {
                        case "cancel":
                            swal("Operação Encerrada", "A reserva não foi cancelada!", "info");
                            break;
                        case "confirm":
                            this.$http.post(api, formData).then((response) => {
                                swal("Sucesso", "Reserva cancelada com sucesso!", "success");
                                setTimeout(() => {
                                    location.reload();
                                }, 1000);
                            });
                            break;
                    }
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data;
                    this.$message(null, message, "error");
                });
        },
        submitMessage(user_id, reserve_id) { // submitMessage - envia notificação personalizada
            if (!this.messageText || this.messageText.trim() === '') {
                this.$message(null, 'Preencha o campo Mensagem!', "error");
                return;
            }

            const formData = {
                user_id,
                reserve_id,
                message: this.messageText
            };

            const api = this.$store.state.api + "reserveVehicle/notifications";

            this.$http.post(api, formData).then(() => {
                swal("Sucesso", "Notificação enviada com sucesso!", "success");
                this.messageText = '';
                this.showMessage = false;
            });
        },
        clean() { // clean - limpa dados e fecha o modal
            this.showMessage = false;
            this.messageText = '';
            this.$emit("changeModal", false);
        }
    }
};
</script>

<style scoped>
.vehicle-info-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.vehicle-data {
    background-color: #f8f9fa;
    border-radius: 6px;
    padding: 15px;
    margin-bottom: 15px;
}

.data-row {
    display: flex;
    margin-bottom: 12px;
    align-items: center;
}

.data-row:last-child {
    margin-bottom: 0;
}

.data-label {
    width: 150px;
    font-weight: 600;
    color: #495057;
}

.data-label i {
    width: 18px;
    color: #f8981d;
    margin-right: 5px;
}

.data-value {
    flex: 1;
    padding-left: 10px;
}

.plate {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 3px 8px;
    font-weight: bold;
    display: inline-block;
}

.km-value {
    font-weight: bold;
    color: #0056b3;
}

.date-highlight {
    color: #f8981d;
    font-weight: 600;
}

.action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    flex-wrap: wrap;
}

.notification-section {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.message-form {
    background-color: #fff3cd;
    border-radius: 6px;
    padding: 15px;
}

@media (max-width: 767px) {
    .data-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .data-label {
        width: 100%;
        margin-bottom: 5px;
    }

    .data-value {
        padding-left: 0;
    }

    .action-buttons,
    .notification-section {
        flex-direction: column;
    }

    .action-buttons .btn,
    .notification-section .btn {
        width: 100%;
        margin-bottom: 10px;
        margin-left: 0 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/ReservedModal.vue